import MobileFive from '@/pages/mobile/five-element-diagram/index.vue';

export const mobileRoutes = [
  {
    path: '/mobile/five-element-diagram',
    component: MobileFive,
    meta: {
      layout: 'empty',
    },
  },
  {
    path: '/mobile/five-element-diagram/:id',
    component: MobileFive,
    meta: {
      layout: 'empty',
    },
  },
];
